/** Все тексты раздела «Эксперты ⇄ организаторы». */
export const ER_COPY = {
  pageTitle: "Запросы экспертов",
  pageText:
    "Эксперты ищут организаторов, чтобы организовать мероприятие и собрать аудиторию. Только офлайн-мероприятия в Турции",
  tabMine: "Мои",
  tabRequests: "Запросы",
  tabOrganizers: "Организаторы",
  wantButton: "Хочу собрать аудиторию",
  wantHint:
    "Организаторы мероприятий в Турции организуют встречу и соберут людей. Услуга платная, условия вы обсуждаете напрямую",
  organizersButton: "Организаторы",
  eventsPlate: "Запросы экспертов",
  eventsPlateText: "Эксперты ищут площадки для своих мероприятий",
  venueCardTitle: "Нужна аудитория для своего мероприятия?",
  venueCardText: "Оставь запрос, и организаторы откликнутся",
  venueCardButton: "Хочу собрать аудиторию",
  venueCardMine: "Мои запросы",

  needCardTitle: "Сначала заполни карточку эксперта, чтобы организаторы видели, кто ты",
  needCardButton: "Заполнить",

  formTitle: "Запрос организаторам",
  howTitle: "Как это работает",
  howSteps: [
    "Опиши мероприятие: тему, город, когда и для кого",
    "Организаторы увидят запрос и пришлют предложения. Отклик не гарантирован",
    "Выберешь подходящего и свяжешься напрямую. Условия и оплату обсуждаете сами",
  ],
  fConditionsHint: "Что готов предложить организатору: оплату, процент от билетов, обмен",
  fTopic: "Тема мероприятия",
  fDescription: "Что за мероприятие и для кого",
  fCities: "В каких городах",
  anyCity: "Любой город",
  fPeriod: "Когда примерно",
  fPeriodPh: "например, в ноябре по выходным",
  fAudience: "На сколько человек рассчитываешь",
  fAudiencePh: "например, 15–30",
  fConditions: "Условия",
  fConditionsPh: "например, бесплатно, оплата организатором, процент от билетов",
  send: "Отправить организаторам",
  topicRequired: "Напиши тему мероприятия",
  sentTitle:
    "Запрос отправлен организаторам. Ответы придут в уведомления и на страницу «Мои запросы»",
  sentClose: "Закрыть",
  toMine: "Мои запросы",

  mineEmpty: "У тебя пока нет запросов. Расскажи, для какого мероприятия ищешь аудиторию",
  offersCount: (n: number) => `Предложений: ${n}`,
  statusOpen: "Открыт",
  statusClosed: "Закрыт",
  close: "Закрыть запрос",
  closed: "Запрос закрыт",

  hostsOffTitle: "Включи «Беру заказы от экспертов» в профиле, и увидишь запросы",
  hostsOffButton: "Включить",
  hostsOn: "Готово, теперь ты видишь запросы экспертов",
  allCities: "Все города",
  requestsEmpty: "Пока нет открытых запросов в твоём городе",
  requestsEmptyAll: "Пока нет открытых запросов",
  expertLabel: "Эксперт",

  organizersEmpty: "Пока никто не включил приём запросов",
  eventsCount: (n: number) => `Опубликованных событий: ${n}`,
  openProfile: "Открыть профиль",
  cityFilterAll: "Все города",

  back: "← Назад",
  notFound: "Запрос не найден или уже закрыт",
  when: "Когда",
  audience: "Сколько человек",
  conditions: "Условия",
  cities: "Города",
  offersTitle: "Предложения организаторов",
  offersEmpty:
    "Пока никто не ответил. Как только организатор пришлёт предложение, придёт уведомление",
  accept: "Принять",
  decline: "Отклонить",
  accepted: "Принято",
  declined: "Отклонено",
  contactTitle: "Контакт для связи",
  noContact: "Контакт не указан в профиле",
  offerFormTitle: "Предложить",
  oMessage: "Что ты можешь предложить",
  oMessagePh: "площадка, сколько людей соберёшь, как продвигаешь",
  oDate: "Когда",
  oPlace: "Где",
  optional: "необязательно",
  sendOffer: "Отправить предложение",
  offerSent: "Предложение отправлено",
  offerRequired: "Напиши, что ты можешь предложить",
  withdraw: "Отозвать",
  withdrawn: "Предложение отозвано",
  ownRequest: "Это твой запрос",
  acceptedForOrganizer: "Эксперт принял твоё предложение. Свяжись с ним:",
  declinedForOrganizer: "Эксперт отклонил предложение",

  hostsSectionTitle: "Для организаторов",
  hostsTitle: "Беру заказы от экспертов",
  hostsReveal: "Я организую мероприятия",
  myRequestTitle: "Мой запрос организаторам",
  servicesCatalog: "Ты в каталоге «Эксперты». Люди находят тебя там и пишут напрямую",
  audienceTitle: "Аудитория и мероприятия",
  mineStats: (r: number, o: number) => `Запросов: ${r}, предложений: ${o}`,
  openMine: "Открыть",
  hostsNote: "Что делаю и какие площадки",
  hostsNotePh: "что делаю, какие площадки, сколько людей собираю",
  hostsHint:
    "Беру заказы от экспертов: организую мероприятие и собираю аудиторию. Услуга платная, условия обсуждаешь с экспертом сам. Ты будешь получать запросы экспертов",
  hostsSaved: "Сохранено",
  openRequests: "Открыть запросы экспертов",

  chatInviteText:
    "Ты организатор. Напиши Дарье в Telegram, и она добавит тебя в чат организаторов Турции",
  chatInviteButton: "Написать в Telegram",
  chatInviteUrl: "https://t.me/bilgengroup",
} as const;

export const ER_HINT =
  "Здесь эксперты ищут организаторов, которые соберут аудиторию. Оставь запрос или откликнись на чужой.";
